import React, { useState, useEffect, useRef } from 'react';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import Spacing from '../Spacing';
import { addPatients } from "../../services/patient";
import Inputmask from 'inputmask';
import { notify, datePickerFormat,  all_insurance_options } from "../../helpers";
import { Drawer } from 'vaul';

export default function AddPatientModal(props) {
  const {    
    reloadData = () =>{},
    reloadDataFilter = {},
    account_id,
    location_id,
    setSelectedValue = () => {},
    setFilter = () => {},
    patientAdd = {},
    setPatientAdd = () => {},
    previousScrollPosition = 0,
  } = props;

  const [insuranceOptions] = useState(all_insurance_options());

  const defaultValues = {
    account_id:account_id,
    location_id:location_id,
    first_name: "",
    last_name: "",
    dob: "",
    sex: "M",
    mobile_phone: "",
    home_phone: "",
    email: "",
    address: "",
    insurance_id: 1,
    insurance_code: "",
    // risk_level: "",
    // last_visit: "",
    colorectal_cs_time_period_months: 12,
  }

  const [formData, setFormData] = useState(defaultValues);
  const dropdownRef = useRef(null);

  const allInsuranceOptions = insuranceOptions?.map((option) => ({
    value: option?.id,
    label: option?.name,
  }));

  const handleInsuranceChange = (selectedOption) => {
    setFormData({ ...formData, insurance_id: selectedOption?.value || "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;    
    if (name === "mobile_phone") {               
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
          mask: '(999) 999-9999',
          showMaskOnHover: false,
          showMaskOnFocus: true,
      }).mask(phoneInputs);
    }
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleChangeDate = (name, value) => {     
    setFormData({
      ...formData,
      [name]: datePickerFormat(value),
    });  
  };

  useEffect(() => {
    setFormData({
      ...formData,
      location_id: location_id,
      account_id: account_id,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location_id, account_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    e.target.disabled = true;

    const response = await addPatients(formData);
    
    if (response.detail) {
      notify('error', response.detail, 2);
    } else { 
      notify("success", response.data.message, 2);
      setFormData(defaultValues);
      setSelectedValue(1);
      const updatedFilter = {
        ...reloadDataFilter,
        patient_type: 1
      };
      setFilter(updatedFilter);
      reloadData(updatedFilter);     
      handleDrawerClose();
    } 
    e.target.disabled = false;   

  };

  const handleDrawerClose = () => {
    setPatientAdd(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={patientAdd} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Add Patient</Drawer.Title>
            <Drawer.Description className="sr-only">Add a new patient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_modal_lg center">
              <div className="docpro_modal">
                <h2 className="docpro_fs_24">Add Patient</h2>

                <form onSubmit={handleSubmit}>            
                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Last Name <span className="docpro_red_color">*</span>
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='last_name' required onChange={handleChange} value={formData.last_name} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        First Name <span className="docpro_red_color">*</span>
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='first_name' required onChange={handleChange}  value={formData.first_name} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Date of Birth <span className="docpro_red_color">*</span>
                      </label>
                      <DatePicker
                        name='dob'
                        selected={formData.dob}
                        className="size_lg"
                        placeholderText='mm/dd/yyyy'
                        onChange={date => handleChangeDate("dob",date)}
                        required                  
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Gender <span className="docpro_red_color">*</span>
                      </label>
                      <select className="docpro_form_field size_lg" name='sex' required onChange={handleChange} >
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        <option value="U">Others</option>
                      </select>
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Phone <span className="docpro_red_color">*</span>
                      </label>
                      <input type="text" className="docpro_form_field size_lg us_phone" name='mobile_phone' required
                        onChange={handleChange}
                        value={formData.mobile_phone}
                        maxLength={20} placeholder='(123) 123 1234' />
                    </div>
                    
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Email
                      </label>
                      <input type="email" className="docpro_form_field size_lg" name='email'
                        onChange={handleChange}
                        value={formData.email}
                      />
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Address
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='address' 
                        onChange={handleChange}
                        value={formData.address}
                      />
                    </div>


                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Insurance Name <span className="docpro_red_color">*</span>
                      </label>
                      <Select
                        required
                        name="insurance_id"
                        options={allInsuranceOptions}
                        placeholder="Search..."
                        isSearchable
                        value={allInsuranceOptions?.find((option) => option?.value === formData?.insurance_id) || null}
                        onChange={handleInsuranceChange}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '40px',
                            borderColor: 'var(--border)',
                            borderRadius: '8px'
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 1050,
                            marginTop: '-2px',
                            borderRadius: '0 0 3px 3px',
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 1050,
                            padding: 0
                          }),
                        }}
                      />
                      {/* <select className="docpro_form_field size_lg" name='insurance_id' value={formData.insurance_id} onChange={handleChange}>
                        {insuranceOptions.map(insurance => (
                          <option key={insurance.id} value={insurance.id}>
                            {insurance.name}
                          </option>
                        ))}
                      </select> */}
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Insurance ID
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='insurance_code' onChange={handleChange} value={formData.insurance_code} />
                    </div>
                    {/* <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Last Visit Date
                      </label>
                      <DatePicker
                        selected={formData.last_visit}
                        className="size_lg"
                        onChange={date => handleChangeDate("last_visit", date)}
                        placeholderText='mm/dd/yyyy'
                      />
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Risk Level
                      </label>
                      <select className="docpro_form_field size_lg" name='risk_level' onChange={handleChange} >
                        <option value="">Select</option>
                        <option value="High">High</option>
                        <option value="Moderate">Moderate</option>
                        <option value="Low">Low</option>
                      </select>
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Measures
                      </label>
                      <select className="docpro_form_field size_lg">
                        <option value="1">Select</option>
                        <option value="2">Select 1</option>
                        <option value="3">Select 2</option>
                      </select>
                    </div> */}
                  </div>

                
                  {/* <Spacing lg="20" sm="20" />
                  <div className="docpro_radio_with_text ">
                    <label> Colorectal Cancer Screening: </label>
                    <input
                      type="number"
                      min={1}
                      max={120}
                      name="colorectal_cs_time_period_months"
                      className="docpro_form_field size_lg" 
                      onChange={handleChange}
                      value={formData?.colorectal_cs_time_period_months}
                    />
                    months
                  </div> */}

                  <Spacing lg="32" sm="32" />
                  <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                    <button
                      className="docpro_bordered_btn docpro_fw_600 size_lg"
                      onClick={() => handleDrawerClose()}
                    >
                      Cancel
                    </button>
                    <button
                      type='submit'
                      className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                      // onClick={() => setActiveModal(!activeModal)}
                    >
                      Save
                    </button>              

                  </div>
                </form>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
